interface ActionType {
  GET_LIST_ANNOUNCEMENTS_START: string;
  GET_LIST_ANNOUNCEMENTS_SUCCESS: string;
  GET_LIST_ANNOUNCEMENTS_FAILURE: string;
}

export const AnnouncementActionTypes: ActionType = {
  GET_LIST_ANNOUNCEMENTS_START: '@@GET_LIST_ANNOUNCEMENTS_START',
  GET_LIST_ANNOUNCEMENTS_SUCCESS: '@@GET_LIST_ANNOUNCEMENTS_SUCCESS',
  GET_LIST_ANNOUNCEMENTS_FAILURE: '@@GET_LIST_ANNOUNCEMENTS_FAILURE'
};

export enum ANNOUNCEMENT_CATEGORY {
  IMPORTANT = 'IMPORTANT',
  NOTICE = 'NOTICE',
  INFORMATION = 'INFORMATION'
}

export interface AnnouncementState {
  announcements?: AnnouncementItem[];
  listAnnouncements?: AnnouncementItem[];
  processing?: 'loading';
  process?: string;
  submitting?: boolean;
  success?: boolean;
  error?: string;
}

export interface AnnouncementItem {
  id: number;
  targetRoles: string[];
  category: ANNOUNCEMENT_CATEGORY;
  title: string;
  text?: string;
  callToActionLabel?: string;
  callToActionLink?: string;
  icon?: string;
  isUserAbleToHide?: boolean;
  noticeType?: string;
}
